<div class="h-full flex flex-col gap-2">
	<div>
		<div class="flex justify-between">
			<atomic-button-group
				[(ngModel)]="currentState"
				[options]="tabOptions"
				[testHook]="testHooks.CurrentStateButtonGroup"
			></atomic-button-group>
		</div>
		<div
			class="flex justify-start mt-2"
			*ngIf="showTagsConvertedWarning$ | async"
		>
			<div>
				<atomic-message-bar
					type="warn"
					[shadow]="false"
					[testHook]="testHooks.MessageBar"
					>Tags have been converted. This document is no longer synced with file
					selections.<button
						(click)="resetDocument()"
						[disabled]="documentUpdating$ | async"
						class="ml-4 font-semibold"
						[testHook]="testHooks.ResetDocumentButton"
					>
						Reset document
					</button></atomic-message-bar
				>
			</div>
		</div>
	</div>
	<div class="min-h-0 flex-1">
		<ng-container *ngIf="currentState === 'editor'">
			<div
				class="h-full grid grid-cols-1 overflow-hidden gap-2 grid-rows-[min-content_1fr]"
			>
				<div class="flex gap-2 items-center">
					<div class="font-bold text-lg pl-2">{{ viewingDocumentTitle }}</div>
					<atomic-kebab-options
						class="ml-1"
						[itemGroups]="documentActions$ | async"
						(onSelect)="onActionSelect($event)"
						[disabled]="documentUpdating$ | async"
						[testHook]="testHooks.KebabOptions"
					></atomic-kebab-options>
				</div>
				<app-documents-matter-editor></app-documents-matter-editor>
			</div>
		</ng-container>
		<ng-container *ngIf="currentState === 'viewer'">
			<app-documents-matter-viewer
				[confirmationAction]="confirmationAction"
				[disabledElements]="disabledElements"
			></app-documents-matter-viewer>
		</ng-container>
	</div>
</div>
